export const isString = str => typeof str === 'string'

// Will automatically handle the cases like ACH b/c of + pattern
export const insertSpaceBeforeCapitalLetter = str => (isString(str) ? str.replace(/([A-Z]+)/g, ' $1').trim() : str)
